import CREATE_CAF_SIGNATURE from './createCAFSignature.gql';
import FACE_MATCH_CREATED from './faceMatchCreated.gql';

export {
  CREATE_CAF_SIGNATURE,
  FACE_MATCH_CREATED,
};
